import { render, staticRenderFns } from "./InventoryOrder.vue?vue&type=template&id=2b7c97f7&scoped=true&"
import script from "./InventoryOrder.vue?vue&type=script&lang=js&"
export * from "./InventoryOrder.vue?vue&type=script&lang=js&"
import style0 from "./InventoryOrder.vue?vue&type=style&index=0&id=2b7c97f7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7c97f7",
  null
  
)

export default component.exports